var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("el-alert", {
        attrs: { title: _vm.$t("home.ScanninTip0313"), type: "success" },
      }),
      _c(
        "el-form",
        {
          ref: "ruleFormRef",
          attrs: {
            inline: true,
            model: _vm.queryForm,
            "label-position": "top",
            size: "large",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("home.scanWaybillOrBagNumber"),
                prop: "waybillBagNumber",
              },
            },
            [
              _c("el-input", {
                ref: "inputRef",
                staticStyle: { width: "320px" },
                attrs: {
                  disabled: _vm.isDisabled,
                  placeholder: _vm.$t("home.inputOrScanner"),
                  clearable: "",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.arrivedOut($event)
                  },
                },
                model: {
                  value: _vm.queryForm.waybillBagNumber,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.queryForm,
                      "waybillBagNumber",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "queryForm.waybillBagNumber",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "btnRow" }, [
        _c("div", { staticClass: "header-button-ri" }, [
          _c("span", { staticClass: "hasScan" }, [
            _vm._v(_vm._s(_vm.$t("GlobalSetObj.swept")) + ":"),
            _c("i", [_vm._v(_vm._s(_vm.queryForm.total))]),
          ]),
        ]),
      ]),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableDataShow,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              prop: "serial",
              width: "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.first
                      ? _c("i", { staticClass: "firstOrder centerBtn" }, [
                          _vm._v(_vm._s("New")),
                        ])
                      : _c("div", { staticClass: "centerBtn" }, [
                          _vm._v(_vm._s(scope.row.serial)),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("home.lastScannedTrackingOrBag"),
              "min-width": "180",
              prop: "scanWaybillNumber",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { class: { firstOrder: scope.row.first } }, [
                      _vm._v(
                        " " + _vm._s(scope.row.scanWaybillNumber || "--") + " "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { margin: "10px 0", float: "right" },
        attrs: {
          "current-page": _vm.queryForm.pageNumber,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [50, 100, 200, 400],
          total: _vm.queryForm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
        },
        [
          _c("audio", {
            ref: "errRef",
            attrs: { src: _vm.errorMp3, controls: "controls" },
          }),
          _c("audio", {
            ref: "okRef",
            attrs: { src: _vm.okMp3, controls: "controls" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }